/* =====================================================
   LANDING PAGE ENCENS - JAVASCRIPT
   Compatible Dawn 15.4 | Corrections GPT-5 appliquées
   ===================================================== */

(function() {
    'use strict';
    
    // Retirer classe no-js
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
    
    // =====================================================
    // COMPTEUR ANIMÉ (Preuve sociale)
    // ===================================================== */
    function animateCounter() {
        const counterElement = document.getElementById('lp-customers-count');
        if (!counterElement) return;
        
        const targetValue = 1400;
        const duration = 2000;
        const startTime = performance.now();
        
        function updateCounter(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const currentValue = Math.floor(progress * targetValue);
            
            counterElement.textContent = `Plus de ${currentValue.toLocaleString('fr-FR')} clients satisfaits`;
            
            if (progress < 1) {
                requestAnimationFrame(updateCounter);
            }
        }
        
        requestAnimationFrame(updateCounter);
    }
    
    // Observer pour compteur
    const observerCounter = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounter();
                observerCounter.disconnect();
            }
        });
    });
    
    const counterElement = document.getElementById('lp-customers-count');
    if (counterElement) {
        const socialProofSection = counterElement.closest('.lp-social-proof');
        observerCounter.observe(socialProofSection || counterElement);
    }
    
    // =====================================================
    // SCROLL REVEAL (Animations au scroll)
    // =====================================================
    const scrollRevealElements = document.querySelectorAll('.lp-scroll-reveal');
    
    const observerScrollReveal = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('revealed');
                observerScrollReveal.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1
    });
    
    scrollRevealElements.forEach(el => {
        observerScrollReveal.observe(el);
    });
    
    // =====================================================
    // FAQ ACCORDION
    // =====================================================
    window.lpToggleFAQ = function(questionElement) {
        const item = questionElement.closest('.lp-faq__item');
        if (!item) return;
        
        const answer = item.querySelector('.lp-faq__answer');
        if (!answer) return;
        
        const isActive = item.classList.contains('active');
        
        // Fermer tous les autres
        document.querySelectorAll('.lp-faq__item.active').forEach(activeItem => {
            if (activeItem !== item) {
                activeItem.classList.remove('active');
                const activeAnswer = activeItem.querySelector('.lp-faq__answer');
                if (activeAnswer) activeAnswer.style.maxHeight = null;
            }
        });
        
        // Toggle l'item actuel
        if (isActive) {
            item.classList.remove('active');
            answer.style.maxHeight = null;
        } else {
            item.classList.add('active');
            answer.style.maxHeight = answer.scrollHeight + 'px';
        }
    };
    
    // =====================================================
    // STICKY CTA MOBILE (avec padding body)
    // =====================================================
    const stickyCTA = document.querySelector('.lp-sticky-cta');
    
    if (stickyCTA) {
        let scrollThreshold = window.innerHeight * 0.2;
        
        // Recalcul du threshold au resize
        window.addEventListener('resize', () => {
            scrollThreshold = window.innerHeight * 0.2;
        }, { passive: true });
        
        window.addEventListener('scroll', () => {
            if (window.scrollY > scrollThreshold) {
                stickyCTA.classList.add('visible');
                document.body.classList.add('lp-sticky-visible');
            } else {
                stickyCTA.classList.remove('visible');
                document.body.classList.remove('lp-sticky-visible');
            }
        }, { passive: true });
    }
    
    // =====================================================
    // SMOOTH SCROLL (avec offset pour header Dawn)
    // =====================================================
    document.querySelectorAll('.lp-smooth-scroll').forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = link.getAttribute('href');
            const target = document.querySelector(targetId);
            if (target) {
                const headerOffset = 80; // Offset pour header Dawn
                const elementPosition = target.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
    
    // =====================================================
    // LIGHTBOX (propagation corrigée)
    // =====================================================
    window.lpOpenLightbox = function(imageElement) {
        const imgSrc = imageElement.querySelector('img').src;
        const lightbox = document.getElementById('lp-lightbox');
        const lightboxImg = document.getElementById('lp-lightbox-img');
        
        lightboxImg.src = imgSrc;
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
    };
    
    window.lpCloseLightbox = function(event) {
        // Ne fermer QUE si clic sur le fond (pas sur l'image)
        if (event && event.target.id !== 'lp-lightbox' && !event.target.classList.contains('lp-lightbox__close')) {
            return;
        }
        
        const lightbox = document.getElementById('lp-lightbox');
        lightbox.classList.remove('active');
        document.body.style.overflow = 'auto';
    };
    
    // Fermeture avec touche Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            const lightbox = document.getElementById('lp-lightbox');
            if (lightbox && lightbox.classList.contains('active')) {
                lpCloseLightbox();
            }
        }
    });
    
    // =====================================================
    // PARALLAX SUBTIL (Hero image) - Desktop uniquement
    // =====================================================
    const heroImage = document.querySelector('.lp-hero__image');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (heroImage && window.innerWidth > 768 && !prefersReducedMotion) {
        let ticking = false;
        
        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const scrolled = window.pageYOffset;
                    const parallaxSpeed = 0.3;
                    heroImage.style.transform = `translateY(${scrolled * parallaxSpeed}px)`;
                    ticking = false;
                });
                ticking = true;
            }
        }, { passive: true });
    }
    
    // =====================================================
    // ADD TO CART DIRECT (Best-sellers)
    // =====================================================
    // Lock GLOBAL pour empêcher ajouts simultanés
    let globalCartLock = false;
    
    document.querySelectorAll('.lp-add-to-cart').forEach(button => {
        button.addEventListener('click', async function(e) {
            e.preventDefault();
            e.stopImmediatePropagation(); // Stop TOUS les listeners
            
            // Vérifier lock global
            if (globalCartLock) {
                console.log('Ajout déjà en cours, ignoré');
                return;
            }
            
            // Vérifier si bouton déjà disabled
            if (this.disabled) {
                console.log('Bouton désactivé, ignoré');
                return;
            }
            
            const variantId = this.getAttribute('data-variant-id');
            if (!variantId) {
                console.error('Pas de variant ID');
                return;
            }
            
            // ACTIVER LOCK IMMÉDIATEMENT
            globalCartLock = true;
            this.disabled = true;
            
            const originalText = this.textContent;
            const originalBg = this.style.background;
            this.textContent = 'Ajout...';
            
            console.log('Ajout produit variant:', variantId);
            
            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        items: [{
                            id: parseInt(variantId),
                            quantity: 1
                        }]
                    })
                });
                
                const data = await response.json();
                console.log('Réponse ATC:', data);
                
                if (response.ok) {
                    // Succès
                    this.textContent = '✓ Ajouté !';
                    this.style.background = '#28a745';
                    
                    // Update cart count
                    fetch('/cart.js')
                        .then(res => res.json())
                        .then(cart => {
                            console.log('Cart total items:', cart.item_count);
                            document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(el => {
                                el.textContent = cart.item_count;
                                if (cart.item_count > 0) {
                                    el.classList.remove('hidden');
                                }
                            });
                        });
                    
                    // Trigger events
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true,
                        detail: { cart: data }
                    }));
                    
                    if (window.Shopify && window.Shopify.PubSub) {
                        window.Shopify.PubSub.publish('cart:refresh');
                    }
                    
                    // Ouvrir notification
                    setTimeout(() => {
                        const cartDrawer = document.querySelector('cart-drawer');
                        const cartNotification = document.querySelector('cart-notification');
                        
                        if (cartDrawer && typeof cartDrawer.open === 'function') {
                            cartDrawer.open();
                        } else if (cartNotification && typeof cartNotification.open === 'function') {
                            cartNotification.open();
                        }
                    }, 100);
                    
                    // Reset bouton après 3s
                    setTimeout(() => {
                        this.textContent = originalText;
                        this.style.background = originalBg;
                        this.disabled = false;
                        globalCartLock = false;
                        console.log('Lock released');
                    }, 3000);
                } else {
                    throw new Error(data.description || 'Erreur ajout panier');
                }
            } catch (error) {
                console.error('Erreur ATC:', error);
                this.textContent = '✗ Erreur';
                this.style.background = '#dc3545';
                
                setTimeout(() => {
                    this.textContent = originalText;
                    this.style.background = originalBg;
                    this.disabled = false;
                    globalCartLock = false;
                }, 3000);
            }
        }, { once: false }); // Ne PAS mettre once:true (on veut pouvoir re-cliquer)
    });
    
})();